import React, { useState } from 'react';
import { APIConnector } from 'src/api/APIConnector';
import 'src/css/vendor/ChangePassword.css'; 
import { LuAlertCircle } from "react-icons/lu";
import { FaCheck } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import ValidatePassword from 'src/helpers/ValidatePassword';

const ChangePassword = ({audience = 'client', username, defaultPassword, redirect = false}) => {
    
    const api = APIConnector();
    const navigate = useNavigate();

	const [success, setSuccess] = useState(null);
	const [error, setError] = useState(null);
	const [currentPassword, setCurrentPassword] = useState(defaultPassword || '');
	const [newPassword, setNewPassword] = useState('');
	const [confirmPassword, setConfirmPassword] = useState('');
	const [submitting, setSubmitting] = useState(false);

	// CHANGE PASSWORD
	const handleChangePassword = (event) => {
		setSuccess(null);
		setError(null);
		event.preventDefault();
		if(newPassword.length < 12) {
			setError("Password must be at least 12 characters in length.");			
			return;
		}
		if (newPassword !== confirmPassword) {
			setError("New and confirm password do not match.");
			return;
		}		  
        if(!ValidatePassword(newPassword)){
            setError("Password does not meet password requirements");
            return;
        }
		
		setSubmitting(true);
		// NCC-E034356-KEF: one request -- the server verifies the current password before changing it.
		api.post(`/web/${audience.toLowerCase()}/password/change`,
			{ oldPassword: currentPassword,
			  password: newPassword })
			.then((res) => {
                // USCIS: an expired-password session is reissued without the expired flag; switch to it.
                if (res && res.token)
                    localStorage.setItem('token', res.token);
                setSuccess("Password Successfully Changed!");
                if(redirect)
                    navigate(`/${audience.toLowerCase()}/home`);
            })
			.catch((err) => {
				setError(err);
				setSubmitting(false);
			});
	}

    return (
    <>
		{ success && <p className="changePasswordNote"><FaCheck className="greenIcon" />&nbsp; {success} &nbsp;</p>}
		{ error && <p className="changePasswordNote"><LuAlertCircle className="redIcon" />&nbsp; {error} &nbsp;</p>}
        <form onSubmit={handleChangePassword} className="passwordContainer">
			<table border="0" width="100%">
			<tbody>
                { username && 
				<tr><td>Username</td>
					<td><input type="text" className="stretch" disabled value={username} /></td>
				</tr>}
				<tr><td>Current Password</td>
					<td><input type="password" className="stretch" value={currentPassword} onChange={(e) => setCurrentPassword(e.target.value)} /></td>
				</tr>
				<tr><td>New Password</td>
					<td><input type="password" className="stretch" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} /></td>
				</tr>
				<tr><td>Confirm Password</td>
					<td><input type="password" className="stretch" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} /></td>
				</tr>
				<tr><td colSpan="2"><br/><small>
					* Passwords must be at least 12 characters in length and contain the following characteristics:
					<ul>
						<li>at least one lower-cased alphabetic character (a-z)</li>
						<li>at least one upper-cased alphabetic character (A-Z)</li>
						<li>at least one number (0-9)</li>
						<li>at least one special character (!@#$%^&amp;*()/&lt;&gt;?|_+-=,.)</li>
					</ul></small>
					</td>
				</tr>
				<tr><td colSpan="2" align="right">			
					<button className="blueBtn" id="changePassBtn" type="submit" disabled={submitting}>Change Password</button></td>
				</tr>
			</tbody>
			</table>
        </form>            
    </>
    );
}

export default ChangePassword;